import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }
    const sessionId = match[1];

    // Clean up the hash from the URL immediately
    window.history.replaceState(null, '', window.location.pathname);

    (async () => {
      try {
        const res = await axios.post(
          `${BACKEND_URL}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true },
        );
        navigate('/', { replace: true, state: { user: res.data } });
      } catch (err) {
        const status = err?.response?.status;
        const detail = err?.response?.data?.detail;
        if (status === 403) {
          const email = typeof detail === 'object' ? detail.email || '' : '';
          const msg = typeof detail === 'object' ? detail.message || '' : '';
          // "not registered" errors go back to staff-login with the reason shown
          if (msg && msg.toLowerCase().includes('not registered')) {
            navigate(`/staff-login?error=${encodeURIComponent(msg)}`, { replace: true });
            return;
          }
          navigate(`/access-denied${email ? `?email=${encodeURIComponent(email)}` : ''}`, { replace: true });
          return;
        }
        const msg =
          typeof detail === 'string'
            ? detail
            : detail?.message || 'Login failed. Please try again.';
        navigate(`/login?error=${encodeURIComponent(msg)}`, { replace: true });
      }
    })();
  }, [location, navigate]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin mx-auto mb-3"></div>
        <p className="text-slate-600 text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
